import { Mic } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Phase 2 Agency: transcripts allowance for Pro+ tiers (Starter has 0).
 *
 * Renders ONLY when `agency.limits.transcripts > 0`. We don't have a
 * per-month "used" counter on the agency context yet (the existing
 * billing/usage/me endpoint returns balances at the company customer
 * level, while agency transcripts live on the OWNER customer in Autumn).
 * So we render the granted allowance only — when the BE exposes a
 * usage field we can swap to a progress-bar layout like the other
 * agency widgets.
 *
 * Hidden for:
 *   - Non-agency users
 *   - Agency Starter (transcripts cap = 0)
 */
export function AgencyTranscriptsWidget() {
  const { user } = useAuth();
  const { t, language } = useLanguage();
  const isIt = language === 'it';

  if (user?.accountType !== 'agency_owner' || !user.agency) return null;

  const limit = user.agency.limits.transcripts ?? 0;
  if (limit <= 0) return null;

  return (
    <Card className="p-4 border-border/60">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-md bg-brand-primary/10 text-brand-primary flex items-center justify-center flex-shrink-0">
          <Mic className="h-4 w-4" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs text-muted-foreground">
            {t('dashboard.agency.transcripts') ?? (isIt ? 'Transcripts' : 'Transcripts')}
          </div>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-lg font-semibold text-foreground">{limit}</span>
            <span className="text-sm text-muted-foreground">
              {isIt ? '/ mese' : '/ month'}
            </span>
          </div>
          <div className="mt-2 text-[11px] text-muted-foreground opacity-70">
            {isIt ? 'Riepilogo consumo in arrivo' : 'Usage breakdown coming soon'}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default AgencyTranscriptsWidget;
